<template>
  <div class="img-v-align">
    <img :src="signal1" :width="userWidth" alt="" v-if="riskProfile === 0" />
    <img
      :src="signal2"
      :width="userWidth"
      alt=""
      v-else-if="riskProfile === 1"
    />
    <img
      :src="signal3"
      :width="userWidth"
      alt=""
      v-else-if="riskProfile === 2"
    />
    <img
      :src="signal4"
      :width="userWidth"
      alt=""
      v-else-if="riskProfile === 3"
    />
    <img
      :src="signal5"
      :width="userWidth"
      alt=""
      v-else-if="riskProfile === 4"
    />
  </div>
</template>

<script>
export default {
  name: "RiskImage",
  props: {
    riskProfile: { required: true, default: 0 },
    userWidth: { required: true, default: "60%" },
  },
  data() {
    return {
      // ======== images ========
      signal1: require("@/assets/images/signal1.svg"),
      signal2: require("@/assets/images/signal2.svg"),
      signal3: require("@/assets/images/signal3.svg"),
      signal4: require("@/assets/images/signal4.svg"),
      signal5: require("@/assets/images/signal5.svg"),
    };
  },
};
</script>
